<div class="ai-chat-container" [class.open]="isOpen">
  <!-- 채팅 창 -->
  <div class="chat-window" [class.open]="isOpen"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       (dragenter)="onDragEnter($event)"
       [class.drag-over]="isDragOver">

    <!-- 드래그 오버레이 -->
    <div class="drag-overlay" *ngIf="isDragOver && !isImageUploadMode">
      <div class="drag-content">
        <div class="drag-icon">📁</div>
        <div class="drag-text">파일을 여기에 놓으세요</div>
        <div class="drag-subtext">PDF, JPG, PNG 파일 지원</div>
      </div>
    </div>

    <div class="chat-header">
      <div class="header-content">
        <img src="/assets/tossface/u1F4AC.svg" class="ai-icon" alt="AI 로봇">
        <div class="header-text">
          <div class="ai-title">AI 상품 어드바이저</div>
          <div class="ai-subtitle">상품 등록/수정을 도와드릴게요</div>
        </div>
      </div>
      <div class="header-actions">
        <button class="debug-btn" (click)="toggleDebugMode()" title="디버그 모드">
          <img src="/assets/tossface/u1F41E.svg" alt="디버그" class="debug-icon" [class.active]="isDebugMode">
        </button>
        <img src="/assets/new/close.svg" class="close-btn" (click)="closeChat()" alt="채팅창 닫기">
      </div>
    </div>

    <div class="rich-html-notice" role="note" *ngIf="isRichHtmlDescription">
      이 상품의 상세 설명은 HTML로 만들어져 있어 AI 어드바이저로 고치면 반영되지 않거나 오래 걸릴 수 있어요.
      상세 설명은 {{ richHtmlEditHint }}
    </div>

        <div class="chat-messages" #messagesContainer>
      <!-- 디버깅 정보 -->
      <div *ngIf="isDebugMode" class="debug-panel">
        <strong class="debug-title">🔍 전체 디버깅 정보</strong>
        <div class="debug-item"><strong>로딩 중:</strong> {{ isLoading }}</div>
        <div class="debug-item"><strong>총 메시지:</strong> {{ messages.length }}</div>

        <div class="debug-item" *ngIf="productContext">
          <strong>상품 컨텍스트:</strong>
          <pre>{{ productContext | json }}</pre>
        </div>
        <div class="debug-item" *ngIf="selectedFiles.length > 0">
          <strong>선택된 파일:</strong>
          <pre>{{ selectedFilesForDebug | json }}</pre>
        </div>

        <div class="debug-item" *ngIf="lastAiMessage">
          <strong>마지막 AI 정보:</strong>
          <div class="debug-sub-item"><strong>토큰:</strong> {{ lastAiMessage.tokensUsed || 'N/A' }}</div>
          <div class="debug-sub-item" *ngIf="lastAiMessage.reasoning">
            <strong>추론:</strong> <pre>{{ lastAiMessage.reasoning }}</pre>
          </div>
        </div>
      </div>

      <div
        *ngFor="let message of messages; trackBy: trackByMessageId"
        class="message"
        [class.user-message]="message.isUser"
        [class.ai-message]="!message.isUser">

        <div class="message-avatar" *ngIf="!message.isUser">
          <img src="/assets/tossface/u1F916.svg" class="avatar-img" alt="AI">
        </div>

        <div class="message-content">
          <!-- 메시지별 디버깅 정보 -->
          <div *ngIf="isDebugMode && !message.isUser" class="debug-panel message-debug-panel">
            <div class="debug-item"><strong>ID:</strong> {{ message.id }}</div>
            <div class="debug-item"><strong>스트리밍:</strong> {{ message.isStreaming }}</div>
            <div class="debug-item"><strong>토큰:</strong> {{ message.tokensUsed || 'N/A' }}</div>
            <div class="debug-item" *ngIf="message.reasoning">
              <strong>추론:</strong> <pre>{{ message.reasoning }}</pre>
            </div>
          </div>

          <div class="message-text" *ngIf="message.content">
            <markdown *ngIf="!message.isUser" [data]="message.content"></markdown>
            <div *ngIf="message.isUser">{{ message.content }}</div>
            <span class="streaming-cursor" *ngIf="message.isStreaming && !message.isUser">|</span>
          </div>

          <div class="message-text loading" *ngIf="!message.content && !message.isUser && message.isStreaming">
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <div class="message-text" *ngIf="!message.content && !message.isUser && !message.isStreaming">
            <em style="color: #999;"></em>
          </div>

          <!-- 첨부파일 표시 -->
          <div class="message-attachments" *ngIf="message.attachments && message.attachments.length > 0">
            <div class="attachment-item" *ngFor="let attachment of message.attachments">
              <div class="file-preview" *ngIf="attachment.type === 'image'">
                <img [src]="attachment.url" [alt]="attachment.name" class="preview-image" [attr.title]="attachment.name">
              </div>
              <div class="file-preview" *ngIf="attachment.type === 'pdf'">
                <div class="pdf-icon">📄</div>
                <div class="file-name">{{ attachment.name }}</div>
              </div>
            </div>
          </div>

        </div>

        <div class="message-avatar" *ngIf="message.isUser">
          <img src="/assets/tossface/u1F464.svg" class="avatar-img" alt="사용자">
        </div>
      </div>

            <!-- 로딩 메시지 -->
      <div class="message ai-message" *ngIf="isLoading">
        <div class="message-avatar">
          <img src="/assets/tossface/u1F916.svg" class="avatar-img" alt="AI">
        </div>
        <div class="message-content">
          <div class="message-text loading">
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 첨부파일 미리보기 -->
    <div class="attachments-preview" *ngIf="selectedFiles.length > 0">
      <div class="attachment-header">
        <span class="attachment-count">📎 {{ selectedFiles.length }}개 파일 첨부됨</span>
        <span class="attachment-hint">메시지를 추가하고 전송하세요</span>
      </div>
      <div class="attachment-item" *ngFor="let file of selectedFiles">
        <div class="attachment-content">
          <div class="file-preview" *ngIf="file.type === 'image'">
            <img [src]="file.url" [alt]="file.name" class="preview-image" [attr.title]="file.name">
          </div>
          <div class="file-preview" *ngIf="file.type === 'pdf'">
            <div class="pdf-icon">📄</div>
          </div>
          <div class="file-info">
            <div class="file-name">{{ file.name }}</div>
            <div class="file-size">{{ formatFileSize(file.size) }}</div>
          </div>
        </div>
        <button type="button" class="remove-file" (click)="removeFile(file.id)" title="파일 삭제">
          ❌
        </button>
      </div>
    </div>

    <!-- 상품 이미지 업로드 UI -->
    <div
      class="image-upload-overlay"
      *ngIf="isImageUploadMode"
      (dragover)="onDragOver($event)"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onProductImageDrop($event)"
      [class.drag-over]="isProductImageDragOver"
    >
      <div class="image-upload-header">
        <h3>상품 이미지 관리</h3>
        <button class="close-btn" (click)="closeImageUploadMode()" title="닫기">&times;</button>
      </div>
      <div class="image-grid">
        <div class="image-tile" *ngFor="let image of productImages; trackBy: trackByImageId">
          <img [src]="image.url" [alt]="image.name" class="product-image" [attr.title]="image.name" [class.loading]="image.isLoading || image.isAnalyzing">
          <div class="tile-overlay" *ngIf="image.isLoading || image.isAnalyzing || image.error">
            <!-- 업로드 진행률 표시기 -->
            <div class="progress-indicator" *ngIf="image.isLoading && image.uploadProgress !== undefined">
              <svg class="progress-ring" width="40" height="40">
                <circle class="progress-ring__circle background" stroke-width="4" fill="transparent" r="18" cx="20" cy="20"/>
                <circle
                  class="progress-ring__circle progress"
                  stroke-width="4"
                  fill="transparent"
                  r="18"
                  cx="20"
                  cy="20"
                  [style.strokeDasharray]="2 * 18 * 3.14159"
                  [style.strokeDashoffset]="2 * 18 * 3.14159 * (1 - (image.uploadProgress || 0) / 100)"
                />
              </svg>
              <span class="progress-text">{{ image.uploadProgress }}%</span>
            </div>

            <div class="analyzing-spinner" *ngIf="image.isAnalyzing"></div>
            <div class="error-indicator" *ngIf="image.error">
              <span class="error-icon">!</span>
              <span class="error-message">{{ image.error }}</span>
            </div>
          </div>

          <!-- 분석 정보 툴팁 -->
          <div class="analysis-tooltip" *ngIf="image.analysis">
            <div class="tooltip-headline">{{ image.analysis.headline }}</div>
            <p class="tooltip-description">{{ image.analysis.description }}</p>
            <div class="tooltip-tags">
              <strong>Objects:</strong> {{ image.analysis.tags?.objects?.join(', ') }}<br>
              <strong>Mood:</strong> {{ image.analysis.tags?.mood_and_style?.join(', ') }}<br>
              <strong>Location:</strong> {{ image.analysis.tags?.location_features?.join(', ') }}<br>
              <strong>Section:</strong> {{ image.analysis.suitable_section }}
            </div>
            <div class="tooltip-hashtags">
              {{ image.analysis.tags?.potential_hashtags?.join(' ') }}
            </div>
          </div>

          <button class="delete-image-btn" (click)="removeProductImage(image.id)" title="이미지 삭제" *ngIf="!image.isLoading && !image.isAnalyzing">&times;</button>
        </div>
        <div class="image-tile add-image-tile">
          <label class="add-image-btn">
            +
            <input type="file" (change)="onProductImageSelect($event)" multiple accept="image/*" style="display: none;">
          </label>
        </div>
      </div>
      <div class="image-upload-footer">
        <button class="confirm-btn" (click)="closeImageUploadMode()" title="완료">완료</button>
      </div>
    </div>

    <div class="chat-input">
      <!-- 숨겨진 파일 입력 -->
      <input
        #fileInput
        type="file"
        multiple
        accept=".pdf,.jpg,.jpeg,.png"
        (change)="onFileSelect($event)"
        style="display: none;">

      <input
        #imageInput
        type="file"
        multiple
        accept="image/*"
        (change)="onFileSelect($event)"
        style="display: none;">

      <form [formGroup]="chatForm" (ngSubmit)="sendMessage()" class="chat-form">
        <textarea
          #messageTextarea
          formControlName="message"
          class="message-input"
          rows="1"
          placeholder="메시지를 입력해보세요. 상품 설명 생성에 도움을 드릴 수 있어요."
          (keydown.enter)="handleEnterKey($event)"
          (input)="autoResizeTextarea(messageTextarea)"
          aria-label="메시지 입력">
        </textarea>
        <div class="input-actions">
          <div class="left-actions">
            <button
              type="button"
              class="action-button history-button"
              (click)="openHistory()"
              title="활동"
              aria-label="활동"
              [disabled]="isLoading">
              <img src="/assets/tossface/u1F55B.svg" class="attach-icon" alt="이전 활동 아이콘">
            </button>
            <div class="model-selector" *ngIf="availableModels.length > 0">
              <button
                type="button"
                class="model-trigger"
                (click)="toggleModelMenu($event)"
                [attr.aria-expanded]="isModelMenuOpen"
                [disabled]="isLoading">
                <span class="model-label">{{ selectedModelLabel }}</span>
                <span class="model-caret" aria-hidden="true">▾</span>
              </button>
              <div class="model-menu" *ngIf="isModelMenuOpen" role="menu">
                <ng-container *ngIf="geminiModels.length > 0">
                  <button
                    type="button"
                    *ngFor="let m of geminiModels"
                    class="model-option"
                    [class.selected]="m.id === selectedModelId"
                    (click)="selectModel(m.id)"
                    role="menuitemradio"
                    [attr.aria-checked]="m.id === selectedModelId">
                    <span class="option-label">{{ m.label }}</span>
                    <span class="option-desc" *ngIf="m.description">{{ m.description }}</span>
                  </button>
                </ng-container>
                <div class="model-separator" *ngIf="geminiModels.length > 0 && claudeModels.length > 0"></div>
                <ng-container *ngIf="claudeModels.length > 0">
                  <button
                    type="button"
                    *ngFor="let m of claudeModels"
                    class="model-option"
                    [class.selected]="m.id === selectedModelId"
                    (click)="selectModel(m.id)"
                    role="menuitemradio"
                    [attr.aria-checked]="m.id === selectedModelId">
                    <span class="option-label">{{ m.label }}</span>
                    <span class="option-desc" *ngIf="m.description">{{ m.description }}</span>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="right-actions">
            <button
              type="button"
              class="action-button image-button"
              (click)="productImageDialog()"
              title="상품 이미지 등록"
              aria-label="상품 이미지 등록"
              [disabled]="isLoading">
              <img src="/assets/tossface/u1F5BC.svg" class="attach-icon" alt="상품 이미지 아이콘">
            </button>
            <button
              type="button"
              class="action-button file-button"
              (click)="openFileDialog()"
              title="PDF, 문서 파일 첨부"
              aria-label="PDF, 문서 파일 첨부"
              [disabled]="isLoading">
              <img src="/assets/tossface/u1F4CE.svg" class="attach-icon" alt="파일 첨부 아이콘">
            </button>
            <!-- 보내기 버튼 -->
            <button
              *ngIf="!isAiResponding"
              type="submit"
              class="send-button"
              title="메시지 전송"
              aria-label="메시지 전송"
              [disabled]="(!chatForm.value?.message?.trim() && selectedFiles.length === 0) || isLoading">
              <div class="send-arrow"></div>
            </button>
            <!-- 중단 버튼 -->
            <button
              *ngIf="isAiResponding"
              type="button"
              class="stop-button"
              (click)="stopStream()"
              title="응답 중단"
              aria-label="응답 중단">
              <div class="stop-icon"></div>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- 채팅 토글 버튼 -->
  <div class="chat-toggle" (click)="toggleChat()" [class.active]="isOpen">
    <img src="/assets/tossface/u1F4AC.svg" *ngIf="!isOpen" class="chat-icon" alt="채팅 아이콘">
    <img src="/assets/new/close.svg" *ngIf="isOpen" class="chat-icon" alt="닫기 아이콘">
    <span class="chat-label">AI 상품 어드바이저</span>
    <span class="beta-badge">BETA</span>
    <div class="chat-badge" *ngIf="!isOpen && messages.length > 1">{{ messages.length - 1 }}</div>
  </div>
</div>
